export default "__VITE_ASSET__dc7b2032__"